import { useState } from 'react';

// material-ui
import { useColorScheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

// project imports
import useConfig from 'hooks/useConfig';

// assets
import MoonOutlined from '@ant-design/icons/MoonOutlined';
import SunOutlined from '@ant-design/icons/SunOutlined';

// ==============================|| HEADER CONTENT - DARK MODE TOGGLE ||============================== //

export default function DarkModeToggle() {
  const { mode, setMode } = useColorScheme();
  const { state } = useConfig();

  const handleToggle = () => {
    setMode(mode === 'light' ? 'dark' : 'light');
  };

  if (!mode) {
    return <Box sx={{ width: 36, height: 36, ml: 1 }} />; // placeholder while hydrating
  }

  const activeStyle = mode === 'light' ? 'light' : (state.darkModeStyle || 'discord-dark');

  const getThemeColor = () => {
    if (mode === 'light') return '#ffa726';
    switch (activeStyle) {
      case 'discord-midnight': return '#9e9e9e';
      case 'discord-classic': return '#7289da';
      case 'discord-glass': return '#8a2be2';
      default: return '#5865f2';
    }
  };

  return (
    <Box sx={{ ml: 1 }}>
      <Tooltip title={`Switch to ${mode === 'light' ? 'Dark' : 'Light'} Mode`}>
        <IconButton
          disableRipple
          color="secondary"
          onClick={handleToggle}
          sx={{ 
            color: getThemeColor(), 
            bgcolor: 'action.hover',
            border: '1px solid',
            borderColor: 'divider',
            transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              bgcolor: 'action.selected',
              boxShadow: `0 0 12px ${getThemeColor()}60`,
              transform: 'scale(1.05)'
            }
          }}
        >
          {mode === 'light' ? <SunOutlined /> : <MoonOutlined />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
